<mat-card appearance="outlined" class="customer-demand-card mat-elevation-z1">
    <mat-card-title class="metric-title">
            {{title}}
    </mat-card-title>
    <mat-card-content>
        <form [formGroup]="fgDemand" autocomplete="off">
            <ng-container formArrayName="rows">

                <ng-container>
                    <mat-table [dataSource]="dataSource" class="gea-mat-table">

                        <ng-container matColumnDef="ShiftDate">
                            <mat-header-cell *matHeaderCellDef>Shift Date</mat-header-cell>
                            <mat-cell *matCellDef="let d; let i = index" [formGroup]="d">
                                <span *ngIf="currentShift || !d.value['isNew']"
                                    [class.deleted]="d.value['isDeleted']">
                                    {{d.value['ShiftDate']}}
                                </span>
                                <mat-form-field *ngIf="!currentShift && d.value['isNew']" appearance="fill" [style.width.px]="125">
                                    <input matInput type="text"
                                        formControlName="ShiftDate"  
                                        maxlength="10"/>
                                <mat-error *ngIf="demandRows.controls[i].get('ShiftDate').errors?.validateDate">Must be valid date YYYY-MM-DD or MM/DD/YYYY</mat-error>
                                <mat-error *ngIf="demandRows.controls[i].get('ShiftDate').errors?.required">Shift Date required</mat-error>
                                </mat-form-field>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Shift">
                            <mat-header-cell *matHeaderCellDef>Shift</mat-header-cell>
                            <mat-cell *matCellDef="let d; let i = index" [formGroup]="d">
                                <mat-form-field appearance="fill" *ngIf="!currentShift && d.value['isNew']">
                                    <mat-select formControlName="Shift" style="font-size: 14px;"  panelClass="custom-size-select-panel-150px custom-size-select-panel">
                                        <mat-option *ngFor="let shift of availShifts" [value]="shift">{{shift}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <span *ngIf="currentShift || !d.value['isNew']" [class.deleted]="d.value['isDeleted']">
                                    {{d.value['Shift']}}
                                </span>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="JobID">
                            <mat-header-cell *matHeaderCellDef>Job ID</mat-header-cell>
                            <mat-cell *matCellDef="let d; let i = index" [formGroup]="d">
                                <span [class.deleted]="d.value['isDeleted']">
                                    {{d.value['JobID']}}
                                </span>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="JobDescription">
                            <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
                            <mat-cell *matCellDef="let d; let i = index" [formGroup]="d">
                                <span *ngIf="!d.value['isNew']" [class.deleted]="d.value['isDeleted']">
                                        {{d.value['JobDescription']}}
                                </span>
                                <mat-form-field *ngIf="d.value['isNew']" appearance="fill" [style.width.px]="300">
                                    <span *ngIf="d.value['isNew']">
                                        <mat-select formControlName="JobIdx" (selectionChange)="selectJobIdx(fgDemand, i, $event)" style="font-size: 14px;" panelClass="custom-size-select-panel-450px custom-size-select-panel">
                                            <mat-option *ngFor="let config of jobConfig; let i = index" [value]="i">{{config.JobID}} - {{config.JobDescription}}</mat-option>
                                        </mat-select>
                                    </span>
                                </mat-form-field>
                            </mat-cell>
                        </ng-container>
            
                        <ng-container matColumnDef="Qty">
                            <mat-header-cell *matHeaderCellDef>Quantity</mat-header-cell>
                            <mat-cell *matCellDef="let d; let i = index" [formGroup]="d">
                                <span *ngIf="!d.value['isEditing']"
                                    [class.deleted]="d.value['isDeleted']">
                                    {{d.value['Qty']}}
                                </span>
                                <mat-form-field *ngIf="d.value['isEditing']" appearance="fill">
                                    <input matInput type="text"
                                            formControlName="Qty"  
                                            maxlength="10"
                                            [style.width.px]="200"/>
                                <mat-error *ngIf="demandRows.controls[i].get('Qty').errors?.validateQty">Invalid</mat-error>
                                <mat-error *ngIf="demandRows.controls[i].get('Qty').errors?.required">Required</mat-error>
                                </mat-form-field>
                            </mat-cell>
                        </ng-container>
            
                        <ng-container matColumnDef="Actions">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let d; let i = index">
                                <button *ngIf="allowEdits && !d.value['isDeleted'] && !d.value['isEditing']" 
                                        mat-button 
                                        color="primary" 
                                        (click)="editLine(fgDemand,i)">
                                        <mat-icon>create</mat-icon>Edit
                                </button>
            
                                <span *ngIf="d.value['ConfigID'] == -1" style="min-width: 64px; max-width: 64px;"></span> 
            
                                <button *ngIf="allowEdits && (!d.value['isDeleted'] && !d.value['isEditing']) || d.value['isNew']" 
                                            mat-button color="warn" 
                                            (click)="delete(fgDemand,i)">
                                    <mat-icon>delete_forever</mat-icon>Delete
                                </button>
                
                                <button *ngIf="(d.value['isEditing'] || d.value['isDeleted']) && !d.value['isNew']" 
                                        mat-button 
                                        color="primary" 
                                        (click)="undo(fgDemand, i)">
                                    <mat-icon>undo</mat-icon>
                                    <span *ngIf="!d.value['isDeleted']">Undo - Edit</span>
                                    <span *ngIf="d.value['isDeleted']">Undo - Delete</span>
                                </button>
                            </mat-cell>
                        </ng-container>
                
                
                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>      
                    </mat-table>
                    <div>
                        <button *ngIf="allowEdits" mat-button color="primary" (click)="add(fgDemand)"><mat-icon>add_circle</mat-icon>Add New</button>
                    </div>
                </ng-container>

            </ng-container>
        </form>

<!-- <button *ngIf="allowEdits" mat-raised-button [disabled]="!fgDemand.dirty || !fgDemand.valid" color="primary" (click)="save()">Save</button>
<span class="spacer"></span>
<button *ngIf="allowEdits" mat-raised-button [disabled]="!fgDemand.dirty || !fgDemand.valid" (click)="cancel()">Cancel</button> -->
</mat-card-content>
</mat-card>